<app-loader></app-loader>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-alert-message *ngIf="sharedService.alertMessageLength>0 || sharedService.alertshowMore"></app-alert-message>